module.exports = require('./helpers/bundle-url').getBundleURL('fjrTL') + "logo.c51670a8.svg";